module.exports = __webpack_public_path__ + "img/500.eff0cfcf.png";